document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.querySelectorAll('[data-language-selector]').forEach((select) => {
  select.addEventListener('change', () => select.form?.submit());
});

const header = document.querySelector('[data-site-header]');
const updateHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 24);
updateHeader();
window.addEventListener('scroll', updateHeader, { passive: true });

if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.reveal').forEach((element) => observer.observe(element));

  const orbit = document.querySelector('.hero-orbit');
  window.addEventListener('pointermove', (event) => {
    if (!orbit || window.innerWidth < 900) return;
    const x = (event.clientX / window.innerWidth - 0.5) * 12;
    const y = (event.clientY / window.innerHeight - 0.5) * 12;
    orbit.style.setProperty('--orbit-x', `${x}px`);
    orbit.style.setProperty('--orbit-y', `${y}px`);
  }, { passive: true });
}
